import { useSelector } from "react-redux";
import { ApplicationState } from "src/store";

export const useSpedState = () => {
  const selectSpedState = (state: ApplicationState) => state.sped;
  return useSelector(selectSpedState);
};
